module.exports = __webpack_public_path__ + "img/stop-c.00539fde.png";